import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/Logo_2.png';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleOnlineCoaching = () => {
    navigate('/consultation-signup');
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white py-4 px-6 md:px-12 flex items-center justify-between sticky top-0 z-50 shadow-sm">
      {/* Logo on left - click to go home */}
      <div
        className="flex items-center cursor-pointer"
        onClick={() => handleNavigation('/')}
      >
        <img
          src={logo}
          alt="Company Logo"
          className="h-10 md:h-24 w-auto object-contain"
        />
      </div>

      {/* Desktop Navigation - hidden on mobile */}
      <nav className="hidden items-center gap-8">
        <button
          onClick={() => handleNavigation('/coaching/fatloss')}
          className="text-gray-800 hover:text-[#fc0100] font-medium bg-transparent border-none cursor-pointer"
        >
          Fat Loss
        </button>
        <button
          onClick={() => handleNavigation('/coaching/strengthtraining')}
          className="text-gray-800 hover:text-[#fc0100] font-medium bg-transparent border-none cursor-pointer"
        >
          Strength Training
        </button>
        <button
          onClick={() => handleNavigation('/coaching/peds')}
          className="text-gray-800 hover:text-[#fc0100] font-medium bg-transparent border-none cursor-pointer"
        >
          Peds
        </button>
        <button
          onClick={() => handleNavigation('/coaching/pcos')}
          className="text-gray-800 hover:text-[#fc0100] font-medium bg-transparent border-none cursor-pointer"
        >
          Pcos
        </button>
        <button
          onClick={() => handleNavigation('/coaching/personalcoaching')}
          className="text-gray-800 hover:text-[#fc0100] font-medium bg-transparent border-none cursor-pointer"
        >
          Personal Coaching
        </button>
      </nav>

      {/* Desktop Button - hidden on mobile */}
      <button
        onClick={handleOnlineCoaching}
        className="hidden md:block bg-[#fc0100] text-white px-6 py-2 rounded-full hover:bg-red-700 transition-colors font-medium"
      >
        Online Coaching
      </button>

      {/* Hamburger Icon - visible only on mobile */}
      <button
        onClick={toggleMenu}
        className="md:hidden text-gray-800 focus:outline-none"
        aria-label="Toggle menu"
      >
        {isMenuOpen ? (
          <X className="w-8 h-8" />
        ) : (
          <Menu className="w-8 h-8" />
        )}
      </button>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 top-[72px] bg-white z-40 md:hidden">
          <div className="flex flex-col p-8 gap-6">
            <button
              onClick={() => handleNavigation('/coaching/fatloss')}
              className="text-gray-800 hover:text-[#fc0100] font-medium text-lg py-3 border-b border-gray-100 text-left bg-transparent"
            >
              Fatloss
            </button>
            <button
              onClick={() => handleNavigation('/coaching/strengthtraining')}
              className="text-gray-800 hover:text-[#fc0100] font-medium text-lg py-3 border-b border-gray-100 text-left bg-transparent"
            >
              Strengthtraining
            </button>
            <button
              onClick={() => handleNavigation('/coaching/peds')}
              className="text-gray-800 hover:text-[#fc0100] font-medium text-lg py-3 border-b border-gray-100 text-left bg-transparent"
            >
              Peds
            </button>
            <button
              onClick={() => handleNavigation('/coaching/pcos')}
              className="text-gray-800 hover:text-[#fc0100] font-medium text-lg py-3 border-b border-gray-100 text-left bg-transparent"
            >
              Pcos
            </button>
            <button
              onClick={() => handleNavigation('/coaching/personalcoaching')}
              className="text-gray-800 hover:text-[#fc0100] font-medium text-lg py-3 border-b border-gray-100 text-left bg-transparent"
            >
              Personal Coaching
            </button>
            <button
              onClick={handleOnlineCoaching}
              className="bg-[#fc0100] text-white px-6 py-4 rounded-full hover:bg-[#fc0100] transition-colors font-medium text-lg mt-4"
            >
              Online Coaching
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
